export const insuranceForDoctorsFaqList = [
  {
    question: 'What is Professional Indemnity Insurance for Doctors?',
    answer:
      'Professional Indemnity Insurance for doctors, offered by PrishaPolicy, provides coverage against legal claims arising from professional negligence, errors, or omissions. It protects medical professionals from financial losses due to lawsuits and legal fees.',
  },
  {
    question: 'Why is Professional Indemnity Insurance important for medical setups?',
    answer:
      'This insurance, available through PrishaPolicy, is crucial for medical setups as it safeguards against potential legal actions from patients. It ensures that healthcare providers can continue their practice without the financial burden of legal claims.',
  },
  {
    question: 'What unique benefits does Motor Insurance from PrishaPolicy offer to doctors?',
    answer:
      'Motor Insurance not only covers damages to your vehicle due to accidents, theft, or natural disasters but also offers special discounts for early renewals. Additionally, our policies include roadside assistance and cashless repairs at network garages, ensuring you are always on the move without hassle.',
  },
  {
    question: 'How does Health and Accidental Insurance benefit doctors?',
    answer:
      'Health and Accidental Insurance provided by PrishaPolicy offers financial support for medical expenses due to illness or injury. It covers hospitalization costs, surgeries, and other medical treatments, ensuring doctors can focus on recovery without financial stress.',
  },
  {
    question: 'What is Cyber Insurance and why do doctors need it?',
    answer:
      'Cyber Insurance protects against data breaches, cyber-attacks, and other online threats. For doctors, it ensures the security of sensitive patient information and covers the costs associated with data recovery and legal actions.',
  },
  {
    question: 'How can Home Insurance from PrishaPolicy protect your valuable assets?',
    answer:
      'Home Insurance from PrishaPolicy provides comprehensive coverage for damages to your home and personal belongings due to fire, theft, or natural disasters. Did you know that doctors can also get additional coverage for medical equipment and professional tools kept at home? This ensures that your practice remains uninterrupted even in the face of unexpected events.',
  },
  {
    question: 'Why does the right Life Insurance product matter?',
    answer:
      'Life Insurance offers financial security to your family in the event of your untimely death. While life insurance is traditionally seen as a safety net, it’s also a strategic financial tool. In the current Indian economy, diversifying your investments is crucial. A basic term life policy combined with a mutual funds portfolio might be a better choice for maximizing returns and ensuring comprehensive/e coverage than ULIP.',
  },
  {
    question: 'How can you choose the right insurance products for your needs?',
    answer:
      'Doctors should assess their specific risks and financial goals. Consulting with a PrishaPolicy insurance advisor can help tailor the right mix of insurance products to provide comprehensive coverage.',
  },
  {
    question: 'What are the benefits of having multiple insurance policies through PrishaPolicy?',
    answer:
      'Having multiple insurance policies from PrishaPolicy ensures comprehensive protection against various risks. It provides peace of mind, knowing that all aspects of your profession and personal life are covered through a single source, and with our dedicated managers you can achieve greater customer satisfaction.',
  },
];
